import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react'
import { WellBoreVisualisation } from './diagram-class'
import { Button } from '@msaf/core-react'
import handleAPIError from '../../errors/handler'

interface DiagramTabProps {
  lithologyJson: string
  setIsDiagramError: Dispatch<SetStateAction<boolean>>
}

export default function LithologyDiagramTab({ lithologyJson, setIsDiagramError }: DiagramTabProps) {
  const [isRendering, setIsRendering] = useState(true)
  let wellBoreVisualisation = useMemo(() => new WellBoreVisualisation('borelog'), [])

  useEffect(() => {
    try {
      setIsRendering(true)
      wellBoreVisualisation.setJson(lithologyJson)
      if (lithologyJson != null) {
        wellBoreVisualisation.buildReferenceElements()
        wellBoreVisualisation.render()
        setIsRendering(false)
      }
    } catch (err: any) {
      handleAPIError(err, { componentStack: 'LithologyDiagramTab' })
      setIsDiagramError(true)
    }
  }, [lithologyJson, wellBoreVisualisation, setIsDiagramError])

  useEffect(() => {
    if (wellBoreVisualisation.isError === true) {
      setIsDiagramError(true)
    }
  }, [wellBoreVisualisation.isError, setIsDiagramError])

  const download = () => {
    let svgElement: any = document.getElementById('borelog_svg')
    let serializedSVG = new XMLSerializer().serializeToString(svgElement)

    wellBoreVisualisation
      .convertSVGToPNG(
        serializedSVG,
        wellBoreVisualisation.getTotalHeight() +
          wellBoreVisualisation.bottomOfBorePadding +
          wellBoreVisualisation.exportHeaderHeight,
        wellBoreVisualisation.boreWidth +
          wellBoreVisualisation.leftOfBoreOffset +
          wellBoreVisualisation.totalVisualisationWidth,
        wellBoreVisualisation.exportMargin,
      )
      .then((data) => {
        wellBoreVisualisation.downloadImage(wellBoreVisualisation.getFilename(), data, 'png')
      })
  }

  const styles = {
    hiddenObjects: {
      height: 0,
      width: 0,
    },
  } as const

  return (
    <>
      <Button
        isSkeleton={isRendering}
        label='Download'
        icon='download'
        iconAlignment='left'
        buttonStyle='secondary'
        onClick={download}
      />
      <br />
      <div id='borelog'></div>
      <div id='assets' style={styles.hiddenObjects}></div>
    </>
  )
}
